export enum NavigationColorMode {
  ALL_COLORS = 'ALL_COLORS',
  CATALOG_PRODUCT_COLORS = 'CATALOG_PRODUCT_COLORS',
}
